module.exports = __webpack_public_path__ + "img/syllabus.e63dae7e.webp";